import GetShopPaymentListRequestModelBase from '../_generated/modelBases/get-shop-payment-list-request-model-base';

export default class GetShopPaymentListRequestModel extends GetShopPaymentListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
